import React from 'react'
import { connect } from 'react-redux'
import c from 'classnames'
import Button from 'discada/dist/Button'
import Icon from 'discada/dist/Icon'

import { goHome } from 'actions/pageStateActions'

import './index.scss'

const goToFrikinTechSite = () => (window.location = 'http://frikintech.com')

export function ErrorPreso({ title, code, description, goHome, frikin }) {
  return (
    <div className={c('error', `error-${code}`)}>
      <h3>{title}</h3>
      <Icon frikin icon="RoadsideAssistance" large />
      <p>{description}</p>
      <div className="call-to-action">
        <Button success onClick={frikin ? goToFrikinTechSite : goHome}>
          Let's try another
        </Button>
      </div>
    </div>
  )
}

export const Error = connect(
  (s, op) => op,
  { goHome },
)(ErrorPreso)


export function ErrorCustom(
    {title,
     description="There's a loose nut behind the wheel of this car.",
     tryAgainFn}) {
    return (
        <div className={c('error')}>
            <h3>{title}</h3>
            <Icon frikin icon="RoadsideAssistance" large />
            <p>{description}</p>
            <div className="call-to-action">
                <Button success onClick={tryAgainFn}>
                    Let's try another
                </Button>
            </div>
        </div>
    )
}

////////////////////////////////////

export const FourOhFour = () => (
  <Error
    code="404"
    title="404 Error"
    description="There's a loose nut behind the wheel of this car."
  />
)

export const FiveHundred = () => (
  <Error
    code="500"
    title="500 Error"
    description="There's a loose nut behind the wheel of this car."
  />
)
